import { translations } from '@dc/ui-library';

export const RECENT_ORDERS_API_ENDPOINT = '/api/my_account/homepage/recent_orders';
export const WISHLIST_API_ENDPOINT = '/api/my_account/homepage/save_for_later';

export const links = [
  {
    id: 'tracking',
    url: '#',
    label: translations.track_this_order,
    attrs: {
      'target': '_blank',
      'data-interaction': 'Orders module: Track order'
    }
  },
  {
    url: translations.need_help_link,
    label: translations.need_help,
    attrs: {
      'data-interaction': 'Orders module: need help'
    }
  }
];
